import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import { GetPagesStatsResponse, GetPagesStatsRequest } from "./Pages.model";
import { GetPagesResponse } from "../journies/Journey.model";

export function usePagesApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getPagesStats: async (params: GetPagesStatsRequest) => {
        const queryParams = new URLSearchParams();

        if (params.startDate) {
          queryParams.append("startDate", params.startDate);
        }

        if (params.endDate) {
          queryParams.append("endDate", params.endDate);
        }

        const url = `/sessions-api/pages/stats${
          queryParams.toString() ? `?${queryParams.toString()}` : ""
        }`;

        return apiResolver<GetPagesStatsResponse>(api.get(url));
      },
      getPageScreenshot: async (pageId: string) => {
        const url = `/sessions-api/pages/${pageId}/screenshot`;
        return apiResolver<string | undefined>(api.get(url));
      },
      getPages: async (params: GetPagesStatsRequest) => {
        const queryParams = new URLSearchParams();
        if (params.startDate) {
          queryParams.append("startDate", params.startDate);
        }
        if (params.endDate) {
          queryParams.append("endDate", params.endDate);
        }
        const url = `/sessions-api/pages${
          queryParams.toString() ? `?${queryParams.toString()}` : ""
        }`;
        return apiResolver<GetPagesResponse>(api.get(url));
      },
    }),
    [api]
  );
}
